import styled from 'styled-components';

export const Title = styled.div`
  font-size: 20px;
  line-height: 1.4;
  margin-bottom: ${(props) => (props.marginBottom ? `${props.marginBottom}` : '20')}px;
  color: #17BFDD;
  font-weight: 900;
  font-family: "Avenir Next LT W01 Demi";
`;

export const SmallTitle = styled.div`
  font-family: 'Avenir Next LT W01 Demi';
  font-size: 14px;
  font-weight: normal;
  align-items: center;
  text-align: left;
  margin-bottom: 5px;
`;
